// Entry bundles (bulmaScripts, panel, ...) are bundled separately, so each one gets its own copy of this
// module. The counter therefore lives on `window` to be shared between all of them.
declare global {
    interface Window {
        __scrollLockCount?: number;
    }
}

export function lockScroll(): void {
    window.__scrollLockCount = (window.__scrollLockCount ?? 0) + 1;
    document.querySelector("html")?.classList.add("is-clipped");
}

export function unlockScroll(): void {
    window.__scrollLockCount = Math.max(0, (window.__scrollLockCount ?? 0) - 1);

    if (window.__scrollLockCount === 0) {
        document.querySelector("html")?.classList.remove("is-clipped");
    }
}
